import {ReactNode} from 'react';

import {flags} from 'libs/rollout';

import {BADGE_CONTENT} from './constants';
import {CtpBadgeValueType} from './types';
import {BADGE_CLASSNAMES, BADGE_VARIATION, BadgeVariationType} from './ui/badge';

/**
 * Checks if flag enabled
 */
export const getIsCtpBadgeRedesign = () => {
    const flagValue = flags.dCTPbadgesRedesign.getValue();
    if (flagValue === 'Variation A' || flagValue === 'Variation B') return true;

    return false;
};

/**
 * Getter for badge content
 */
const getBadgeContent = (badgeId: CtpBadgeValueType): ReactNode => {
    if (BADGE_CONTENT[badgeId]) {
        return BADGE_CONTENT[badgeId];
    }

    return '';
};

const getBadgeVariation = (): BadgeVariationType => {
    const flagValue = flags.dCTPbadgesRedesign.getValue();

    if (flagValue === 'Variation A') {
        return BADGE_VARIATION.PRIMARY;
    }

    return BADGE_VARIATION.SECONDARY;
};

const getBadgeClassname = (id: CtpBadgeValueType) => {
    if (BADGE_CLASSNAMES[id]) {
        return BADGE_CLASSNAMES[id];
    }

    return '';
};

/**
 * Getter for props
 */
export const getBadgeProps = (id: CtpBadgeValueType) => {
    const props = {
        className: getBadgeClassname(id),
        content: getBadgeContent(id),
        variation: getBadgeVariation(),
    };

    return props;
};
